import type { Category, CategoryType } from "mws-ts-v2-sdk";

export const filterCategory = (
  item: { categories: Category[] },
  type: CategoryType,
) =>
  item.categories.find(
    ({ externalReference }) => externalReference?.type === type,
  );
